import React from "react";
import PropTypes from "prop-types";
import {
  AddEventModal,
  EditEventModal,
  InfoEventModal,
  DeleteEventModal,
} from "./EventModals";

const EventModalsWrapper = ({
  modals,
  toggleModal,
  forms,
  updateForm,
  selected,
  canEdit,
  submitEvent,
  deleteEvent,
  setSelected,
}) => {
  return (
    <>
      <InfoEventModal
        open={modals.info}
        onClose={() => toggleModal("info")}
        event={selected}
        canEdit={canEdit}
        onEdit={(ev) => {
          setSelected(ev);
          updateForm("event", "title", ev.title || "");
          updateForm("event", "description", ev.description || "");
          updateForm("event", "start", ev.start?.split("T")[0] || "");
          updateForm("event", "end", ev.end?.split("T")[0] || "");
          updateForm("event", "color", ev.color || "#8b5cf6");
          toggleModal("edit");
        }}
        onDelete={(ev) => {
          setSelected(ev);
          toggleModal("delete");
        }}
      />

      <AddEventModal
        open={modals.add}
        onClose={() => toggleModal("add")}
        formData={forms.event}
        onChange={(e, { name, value }) => updateForm("event", name, value)}
        onSubmit={() => submitEvent("add")}
        disableSubmit={
          !forms.event.title || !forms.event.start || !forms.event.end
        }
      />

      <EditEventModal
        open={modals.edit}
        onClose={() => toggleModal("edit")}
        formData={forms.event}
        onChange={(e, { name, value }) => updateForm("event", name, value)}
        onSubmit={() => submitEvent("edit")}
        disableSubmit={
          !forms.event.title || !forms.event.start || !forms.event.end
        }
      />

      <DeleteEventModal
        open={modals.delete}
        onClose={() => toggleModal("delete")}
        event={selected}
        onDelete={deleteEvent}
      />
    </>
  );
};

EventModalsWrapper.propTypes = {
  modals: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  forms: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
  selected: PropTypes.object,
  canEdit: PropTypes.bool.isRequired,
  submitEvent: PropTypes.func.isRequired,
  deleteEvent: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
};

export default EventModalsWrapper;
